import React from "react";
import right from "../../assets/right.png";
import vidImage from "../../assets/vidImage.png";
import bg_ourApp from "../../assets/bg_ourApp.png";
import android from "../../assets/android.png";
import apple from "../../assets/apple.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OurApp2 = () => {

  const { t, i18n } = useTranslation();

  const { language } = i18n;

  return (
    <div className="my-20 px-20 max-lg:px-5 relative">
      <div className="text-center">
        <h2 className="text-[#14294F] text-3xl max-lg:text-2xl font-semibold">
          {t("Download Our App NOW")}
        </h2>
        <p className="text-[#737E91] text-lg mt-3">
          {t("And enjoy exclusive deals & promotions")}
        </p>
      </div>
      <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 lg:items-center lg:px-20">
        <div>
          <div className="flex items-center mt-7">
            <img src={right} className="w-[45px]" />
            <p className={`text-[#14294F] text-xl ${language == "en" ? "ml-5" : "mr-5"}`}>{t("Easy service booking")}</p>
          </div>
          <div className="flex items-center mt-7">
            <img src={right} className="w-[45px]" />
            <p className={`text-[#14294F] text-xl ${language == "en" ? "ml-5" : "mr-5"}`}>
              {t("Seamless product purchases")}
            </p> 
          </div>
          <div className="flex items-center mt-7">
            <img src={right} className="w-[45px]" />
            <p className={`text-[#14294F] text-xl ${language == "en" ? "ml-5" : "mr-5"}`}>
               {t("Request previews for home services")}
            </p>
          </div>
          <div className="flex items-center mt-7">
            <img src={right} className="w-[45px]" />
            <p className={`text-[#14294F] text-xl ${language == "en" ? "ml-5" : "mr-5"}`}>
              {t("Access to exclusive deals and offers")}
            </p>
          </div>
        </div>
        <div>
          <div className="mt-6 w-2/3 mx-auto">
            <div>
              <div className="bg-[#FCFBFA] rounded-2xl flex items-center border-2 border-[#EAA182] w-[330px] h-[90px] mx-auto max-lg:w-full">
                <img src={android} className="w-[50px] mx-7 max-lg:mx-5" />
                <div className="text-[#3B3D42]">
                  <p className="text-sm">{t("Download on")}</p>
                  <p className="text-2xl max-lg:text-lg font-semibold">
                    {t("Google Play")}
                  </p>
                </div>
              </div>
              <div className="flex mx-auto">
                <Link
                  to="https://play.google.com/store/apps/details?id=com.dtag.samoolah.customer"
                  className="bg-[#FE9B71] text-white rounded-full px-6 py-3 mt-5 mx-auto"
                >
                  {t("DOWNLOAD_NOW")}
                </Link>
              </div>
            </div>
            <div>
              <div className="bg-[#FCFBFA] rounded-2xl flex items-center border-2 border-[#EAA182] w-[330px] h-[90px] mx-auto mt-8 max-lg:w-full">
                <img src={apple} className="w-[50px] mx-7 max-lg:mx-5" />
                <div className="text-[#3B3D42]">
                  <p className="text-sm">{t("Download on")}</p>
                  <p className="text-2xl max-lg:text-lg font-semibold">
                    {t("APP_STORE")}
                  </p>
                </div>
              </div>
              <div className="flex mx-auto">
                <Link
                  to="https://apps.apple.com/sa/app/samoolah/id6478872148"
                  className="bg-[#FE9B71] text-white rounded-full px-6 py-3 mt-5 mx-auto"
                >
                  {t("DOWNLOAD_NOW")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurApp2;
